module.exports = __webpack_public_path__ + "img/artwork-7.008cc97d.png";